export default "__VITE_ASSET__Bg$Ha8Nt__"